import { startOfMonth, startOfDay, addMonths, differenceInDays, format, getDate } from "date-fns";

export const daysUntilNextMonth = () => {
  const today = startOfDay(new Date());
  const nextMonthStart = startOfMonth(addMonths(today, 1));
  return differenceInDays(nextMonthStart, today);
};

export const dreamJobStatusText = (
  t: (key: string, options?: Record<string, unknown>) => string,
) => {
  const today = new Date();
  if (getDate(today) <= 15) {
    return t("the_month_of", { month: format(today, "MMMM") });
  }
  return t("days_left", { count: daysUntilNextMonth() });
};

export const formatDate = (isoString?: string | null, locale?: string): string | null => {
  if (!isoString) return null;
  try {
    const date = new Date(isoString);
    if (Number.isNaN(date.getTime())) return null;
    const resolvedLocale =
      locale ||
      (typeof navigator !== "undefined" && (navigator.language || navigator.languages?.[0])) ||
      "en";
    return date.toLocaleDateString(resolvedLocale, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return null;
  }
};
